import { UploadIcon } from '@repo/ui/icons'
import Modal from '@repo/ui/modal'

import { DpaeAcknowledgmentReceiptInput } from '../../../lib/types/models/mission-tracking/mission-tracking-input'
import { ValidationButton } from '../../../lib/utils/buttons-config/validation-buttons-config'
import { DapeAcknowledgmentReceiptForm } from './dpae-form'

type Props = {
  isOpen: boolean
  onCancel: () => void
  buttonsConfig: ValidationButton<DpaeAcknowledgmentReceiptInput>[]
}

const DpaeFormModal = ({ buttonsConfig, isOpen, onCancel }: Props) => {
  return (
    <Modal
      hideActions
      size={'medium'}
      icon={UploadIcon}
      title={'Importer AR DPAE'}
      isOpen={isOpen}
      onCancel={onCancel}
    >
      <DapeAcknowledgmentReceiptForm buttonsConfig={buttonsConfig} />
    </Modal>
  )
}

export default DpaeFormModal
